import { action, createRequestTypes } from '../base';

export const generalConfigurationActionTypes = {
  GET_GENERAL_CONFIGURATION: createRequestTypes('GET_GENERAL_CONFIGURATION'),
  UPDATE_GENERAL_CONFIGURATION: createRequestTypes('UPDATE_GENERAL_CONFIGURATION'),
};

/**
 * @param payload
 * @param EntityType
 * @param callback
 */
class GeneralConfigurationActions {
  /**
   * @param {*} entityType
   * @return
   */
  getGeneralConfiguration = (entityType, callback) => action(generalConfigurationActionTypes.GET_GENERAL_CONFIGURATION.REQUEST, {
    entityType, callback,
  })

    /**
     *
     * @param {*} getGeneralConfigurationLoading
     * @param {*} entityType
     * @return
     */
    getGeneralConfigurationLoading = (getGeneralConfigurationLoading, entityType) => action(generalConfigurationActionTypes.GET_GENERAL_CONFIGURATION.LOADING, {
      getGeneralConfigurationLoading,
      entityType,
    })

     /**
      * @return
      * @param getGeneralConfiguration
      * @param entityType
      */
     getGeneralConfigurationSuccess = (getGeneralConfiguration, entityType) => action(generalConfigurationActionTypes.GET_GENERAL_CONFIGURATION.SUCCESS, {
       getGeneralConfiguration,
       entityType,
     })

     updateGeneralConfiguration = (payload, callback) => action(generalConfigurationActionTypes.UPDATE_GENERAL_CONFIGURATION.REQUEST, {
       payload,
       callback,
     })

     /**
      *
      * @param {*} updateGeneralConfigurationLoading
      * @return
      */
     updateGeneralConfigurationLoading = (updateGeneralConfigurationLoading) => action(generalConfigurationActionTypes.UPDATE_GENERAL_CONFIGURATION.LOADING, {
       updateGeneralConfigurationLoading,
     })
}

export default new GeneralConfigurationActions();
